import React, { useMemo } from 'react'
import useStyles from './styles'
import { Box, Typography } from '@material-ui/core'
import classnames from 'clsx'
import useNameStyle from 'hooks/useNameStyle'
import { formatMoney } from 'accounting'
import { useSelector } from 'react-redux'
import { capitalize } from 'inflection'
import getPastTense from 'utils/past-tense'
//These hooks are not currently being used, removed to fix linting errors
//import useDonationName from 'hooks/useDonationName'
//import useBidderName from 'hooks/useBidderName'
//import usePurchaserName from 'hooks/usePurchaserName'

const UserAction = ({ data }) => {
  const classes = useStyles()
  const nameStyle = useNameStyle(data.name)
  const useAnonymous = useMemo(() => {
    if (data.anon === '1' || data.anon === 1) {
      return 'Anonymous'
    } else {
      return nameStyle
    }
  }, [nameStyle, data.anon])
  const styledName = useMemo(() => {
    if (useAnonymous === 'paddle_number') {
      if (data.paddle_number) {
        return data.paddle_number
      } else if (data.phone) {
        return data.phone.substr(data.phone.length - 4)
      } else {
        return 'Anonymous'
      }
    } else {
      return useAnonymous
    }
  }, [useAnonymous])

  const event = useSelector(state => state.event.event)

  // handles verb for 'fixed' item types (ie. vote / regular purchase)
  const itemVerb = useMemo(() => {
    if (event.event_type_verb) {
      return capitalize(getPastTense(event.event_type_verb))
    } else if (event.auction_format === 10) {
      return 'Voted'
    } else {
      return 'Purchased'
    }
  }, [event.auction_format, event.event_type_verb])

  // handles action verb for specified type of action taken
  const actionVerb = useMemo(() => {
    if (data.type === 'bid') {
      return 'Bid'
    } else if (data.type === 'donation') {
      return 'Donated'
    } else {
      return itemVerb
    }
  }, [itemVerb, data.type])

  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )

  const mine = useMemo(() => {
    return data.user_id === authenticatedUser.user_id
  }, [data.user_id, authenticatedUser.user_id])

  return (
    <Box
      className={classnames(classes.userAction, {
        [classes.bidAction]: data.type === 'bid',
        [classes.donateAction]: data.type === 'donation',
        [classes.purchaseAction]: data.type === 'purchase',
        [classes.userActionMine]: mine
      })}
    >
      <Typography variant="h2" className={classes.userName}>
        {styledName} {actionVerb}
      </Typography>
      <Typography variant="h2" className={classes.actionAmount}>
        {formatMoney(data.amount, '$', 0)}
      </Typography>
    </Box>
  )
}

export default UserAction



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatList/UserAction/index.jsx